import {
	BurgerMenu,
	DropdownLanguage,
	FavoriteButton,
	Filters,
	Logo,
	MenuNavBar,
	SelectCity,
} from '../components';
import ShortFilter from '@/components/shortFilter/ShortFilter';
import React from 'react';
import {
	Burger,
	Button,
	ButtonLink,
	Dropdown,
	Icon,
	Toggle,
} from '@/components/ui';
import {
	setAuthorisationAccessType,
	setAuthorizationStatus,
} from '@/stores/slices/popupSlice';
import useLadyService from '@/services/LadyService';
import { useSelector } from 'react-redux';
import { getScrolledClass } from '@/stores/slices/headerSlice';
import { setShowTariffsGuestPopup } from '@/stores/slices/popupSlice';

const Default = () => {
	const { dispatch, userType, t, windowWidth, lang } = useLadyService();

	const scrolledClass = useSelector(getScrolledClass);

	const infoLinks = [
		{ id: 1, link: `/${lang}/about`, name: t('about') },
		{ id: 2, link: `/${lang}/guide`, name: t('guide') },
		{ id: 4, link: `/lk/support`, name: t('support') },
	];
	const isJsdom =
		typeof window !== 'undefined' &&
		window.navigator.userAgent.includes('jsdom');
	const LogInButton = () => (
		<>
			{!isJsdom && (
				<Button
					onClick={() => dispatch(setAuthorizationStatus(true))}
					clazz="button--green user__log-in"
				>
					{t('login')}
				</Button>
			)}
		</>
	);

	const RegistrationLinkIndi = (iconSize = 'l', square = false) => {
		return (
			<div className="d-flex fd-row gap-8 ">
				<Button
					clazz={'add-form button button_outline--green'}
					title={t('tariffs')}
					onClick={() => {
						dispatch(setShowTariffsGuestPopup(true));
					}}
				>
					<Icon
						style={{ fontSize: '16px' }}
						size={iconSize}
						spritePath={'erocoin'}
					/>

					{!square && t('tariffs')}
				</Button>
				<ButtonLink
					href={`/${lang}/registration#indi`}
					title={t('add')}
					clazz={
						'add-form button button_outline--green _no-underline '
					}
				>
					<Icon
						size={iconSize}
						spritePath={'plus'}
					/>
					{!square && t('add')}
				</ButtonLink>
			</div>
		);
	};

	if (windowWidth > 1199.98 || isJsdom)
		return (
			<>
				<div className="header__top">
					{RegistrationLinkIndi('s')}

					{!isJsdom ? (
						<Dropdown
							buttonClass={'_no-fill text-nowrap fz-13	'}
							size={'xs'}
							title={t('forusers')}
						>
							{infoLinks.map((i) => {
								if (i.id === 4 && userType === 'default') {
									return (
										<ButtonLink
											onClick={(e) => {
												e.preventDefault();
												dispatch(
													setAuthorisationAccessType(
														'support',
													),
												);
												dispatch(
													setAuthorizationStatus(
														true,
													),
												);
											}}
											href={i.link}
											clazz={'language'}
											title={i.name}
											key={i.id}
											children={i.name}
										/>
									);
								}

								return (
									<ButtonLink
										href={`${i.link}`}
										clazz={'language'}
										title={i.name}
										key={i.id}
										children={i.name}
									/>
								);
							})}
						</Dropdown>
					) : (
						<>
							{infoLinks.map((i) => {
								if (i.id === 4 && userType === 'default') {
									return <></>;
								}

								return (
									<a
										key={i.id}
										href={i.link}
										className="language"
									>
										{i.name}
									</a>
								);
							})}
						</>
					)}

					<DropdownLanguage />

					<Toggle
						type={'theme'}
						id={'theme-main-toggle'}
					/>
				</div>

				<div
					className={
						isJsdom ? 'header__bottom ssr' : 'header__bottom'
					}
				>
					<Logo scrolledClass={scrolledClass} />

					<SelectCity />

					<Filters />

					{!isJsdom && (
						<div className="user__wrapper">
							{<FavoriteButton size={'s'} />}

							{<LogInButton />}
						</div>
					)}
				</div>
			</>
		);

	if (windowWidth > 767.98)
		return (
			<div className={isJsdom ? 'header__bottom ssr' : 'header__bottom'}>
				<Logo scrolledClass={scrolledClass} />

				<SelectCity />

				<Filters />

				<div className="user__wrapper">
					<LogInButton />

					<FavoriteButton size={'s'} />

					{RegistrationLinkIndi('l', true)}

					<DropdownLanguage size={'s'} />

					<Burger />

					<Toggle
						type={'theme'}
						id={'theme-main-toggle'}
					/>

					<BurgerMenu />
				</div>
				<ShortFilter />
			</div>
		);

	return (
		<div className="header__top">
			<div className="user__wrapper">
				{RegistrationLinkIndi('l', true)}

				<Toggle
					type={'theme'}
					id={'theme-main-toggle'}
				/>
			</div>

			<Logo scrolledClass={scrolledClass} />

			<div className="user__wrapper">
				<DropdownLanguage />

				<Burger />
			</div>

			<BurgerMenu />

			<MenuNavBar />

			<ShortFilter />
		</div>
	);
};

export default Default;
